import { loadStripe } from "@stripe/stripe-js";

import { config } from "@/config";

const stripeService = await loadStripe(config.stripe.publicApiKey);

export { stripeService };
